
  function toggleProductGrid(lines) {
    
    const productGrid = document.getElementById('product-grid');
    
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-2');
    
     if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    } else if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    }else if (lines === 5) {
        productGrid.classList.add('collection__page-products');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    let cartButtons = document.querySelectorAll(".card-wrapper .card-information__button");
    if (cartButtons.length > 0) {
      cartButtons.forEach((button) => {
        if (button.parentNode && !button.classList.contains("st-cart-btn")) { 
          button.classList.add("st-cart-btn");

          let parent = button.parentNode;
          let clone = button.cloneNode(true);
          parent.replaceChild(clone, button);
        }
      });
    }

    let quickViewDrawers = document.querySelectorAll(".card-wrapper quick-view-drawer");
    if (quickViewDrawers.length > 0) {
      quickViewDrawers.forEach((drawer) => {
        if (drawer.parentNode) { 
          let parent = drawer.parentNode;
          let clone = drawer.cloneNode(true);
          parent.replaceChild(clone, drawer);
        }
      });
    }
  }, 1000);
});


